<!--
 * @Author: your name
 * @Date: 2022-04-27 09:35:26
 * @LastEditTime: 2025-04-03 14:59:05
 * @LastEditors: 番茄炒蛋蛋 wzh15802755802@163.com
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: \jzjy\src\views\ActiveCenter\index.vue
-->
<template>
  <div id="container">
    <main>
      <!-- 上半部分 -->
      <div class="top" >
        <div class="bangdan">
            <div class="topPic">
                <img src="../../assets/img/5.0/tecStudio (5).png" alt="">
            </div>
            <div class="bangTecLists">
                <div class="tec" v-for="item in tecList" :key="item.id">
                    <div class="pic">
                        <img :src="item.file_url" alt="">
                    </div>
                    <div class="msg">
                        <div class="title">
                            <h3>{{item.title}}</h3>
                            <img src="../../assets/img/5.0/tecStudio (3).png" alt="">
                        </div>
                        <p>资源累计：<span>{{item.res_num}}份</span></p>
                    </div>
                </div>
            </div>
            <div class="sqrz" @click="gomsrz">
                申请入驻
            </div>
        </div>
        <div class="tecBox" v-for="item in tecList" :key="item.id" @click="gomsDetails(item.id)">
            <div class="tips" >进入专栏</div>
            <div class="pic">
                <img :src="item.file_url" alt="">
            </div>
            <div class="msg">
                <div class="title">
                    <h3>{{item.title}}</h3>
                    <img src="../../assets/img/5.0/tecStudio (3).png" alt="">
                </div>
                <div class="subtitle">{{item.sub_title}}</div>
            </div>
            <div class="bottom">
                <p style="margin-left:27px">{{item.versions_title}}</p>
                <p style="margin-right:27px">资源累计：<span>{{item.res_num}}</span>份</p>
            </div>
        </div>
      </div>
      <!-- 合作名师 -->
    <div class="teschers" >
      <div class="boxtitle">
        <div class="left">
          <h4>合作名师</h4>
        </div>
        <!-- <div class="right" @click="goActiveCenter">查看更多</div> -->
      </div>
      <div class="gongzuoshi">
        <div class="gzsBox" v-for="item in msLists" :key="item.id">
          <div class="left" @click="gomsDetails(item.id)">
            <div class="pic">
              <img :src="item.file_url" alt="">
            </div>
            <div class="msg">
              <h4>{{item.title}}</h4>
              <p>{{item.sub_title}}</p>
              <div class="zylj">资源累计：<span>{{item.res_num}}份</span></div>
            </div>
            <div class="tip" v-if="item.versions_title">{{item.versions_title}}</div>
          </div>
          <div class="right">
            <div class="fileList" v-for="list in item.tj_res_list.slice(0, 2)" :key="list.id"  @click="goresDetails(list.row_id, '', list.suffix)">
              <div class="pic">
                <img
                  src="../../assets/img/resFile (1).png"
                  alt="file_url"
                  v-if="
                    list.suffix == 'ppt' ||
                    list.suffix == 'pptx' ||
                    list.suffix == 'ppsx' ||
                    list.suffix == 'pps'
                  "
                />
                <img
                  src="../../assets/img/resFile (2).png"
                  alt="file_url"
                  v-if="list.suffix == 'mp4' || list.suffix == 'rm'"
                />
                <img
                  src="../../assets/img/resFile (3).png"
                  alt="file_url"
                  v-if="list.suffix == 'xls' || list.suffix == 'xlsx'"
                />
                <img
                  src="../../assets/img/resFile (4).png"
                  alt="file_url"
                  v-if="list.suffix == 'zip' || list.suffix == 'rar'"
                />
                <img
                  src="../../assets/img/resFile (5).png"
                  alt="file_url"
                  v-if="list.suffix == 'm4a' || list.suffix == 'mp3'"
                />
                <img
                  src="../../assets/img/resFile (6).png"
                  alt="file_url"
                  v-if="list.suffix == 'doc' || list.suffix == 'docx'"
                />
                <img
                  src="../../assets/img/resFile (7).png"
                  alt="file_url"
                  v-if="list.suffix == 'pdf'"
                />
                <img
                  src="../../assets/img/resFile (8).png"
                  alt="file_url"
                  v-if="list.suffix == 'png' || list.suffix == 'jpg'"
                />
              </div>
              <div class="msg">
                <h4>{{list.row_title}}</h4>
                <p>{{timeStamp2String(list.create_time*1000,2)}}</p>
              </div>
            </div>
            <p @click="gomsDetails(item.id)">查看全部</p>
          </div>
        </div>
      </div>
      <div class="msBanner" @click="gomsrz">
        <div class="pic"  >
          <img src="../../assets/img/5.0/img01.png" alt="">
        </div>
        <div class="msru">申请入驻</div>
      </div>
    </div>
    </main>
  </div>
</template>

<script>
import { timeStamp2String } from "../../utils/time";
import YuyueBox from "../../components/yuyueBox/yuyueBox.vue"; // vue2
import UserInfoBox from "../../components/userInfoBox/userInfoBox.vue"; // vue2
import {
  userinfo,
  list_starteacherstudio,
  islogin,
} from "../../api/http";
export default {
  inject: ["reload"],
  metaInfo () {
    return {
      title: '精准教研教学平台-专注教师教研与教学服务，助力教师专业提升！',
       meta: [{ 
        name: 'Keywords',
        content: '教研教学平台,教学资源,同步教研,课件下载,同步课件,备课资源,教师培训,教师研修,人教版课件,在线教研,新高考'
      }, {
        name: 'description',
        content: '精准教研教学平台是一个专门为全国高中教师打造的教研教学服务平台，侧重高中教材同步精品资源下载（课件、教案、学案、试卷、素材、练习等）、体系化公益教研活动直播、专家名师工作室优质资源共享等。精准定位教学需求，助力提升教学水平，是高中教师随时随地的教研教学小助手。'
      }],
    }
  },
  data() {
    return {
      timeStamp2String,
      nowKm:1,//当前页面的科目，未登录默认语文

      login_status:'',
      tecList:[],
      msLists:[],//名师工作室列表
    };
  },
  components: {
    UserInfoBox,
    YuyueBox,
  },
  created() {
    
    
    
    
    //回到顶部
    $(document).ready(function () {
      $(window).scrollTop(0);
    });
    this.timeNow = Date.now();

    islogin().then(res=>{
      this.login_status = res.retRes.login_status;
      if(this.login_status == 1){
        //判断过期
        userinfo({
          md5key: localStorage.getItem("md5key"),
        }).then((res) => {
          // if (res.retRes.sy_end_time * 1000 < Date.parse(new Date())) {
          //   this.$router.push({
          //     name: "Login",
          //     query: {
          //       isgq: 1,
          //     },
          //   });
          // } else {
            const data = res.retRes;
            this.file_url = data.file_url;
            this.radio1 = this.kemu_id = data.kemu_id;
            this.kejianversions_id = data.kejianversions_id;
            this.nianji_id = data.nianji_id;
            this.getLists();
          // }
        });
      }else{
        this.kemu_id = localStorage.getItem('tckm')?localStorage.getItem('tckm'):'';
        this.nianji_id = localStorage.getItem('tckm')?localStorage.getItem('tcnj'):'';
        this.kejianversions_id = localStorage.getItem('tckm')?localStorage.getItem('tcbb'):'';
        this.getLists();
      }
    })
    
  },
  mounted() {
    //重定向
    localStorage.setItem("path", "");
  },
  beforeDestroy() {
  },
  methods: {
    //获取
    getLists() {
      list_starteacherstudio({
        md5key: localStorage.getItem("md5key"),
        kemu_id:this.kemu_id,
        page_size:4,
      }).then(res=>{
        if(res.retRes.length>= 3){
            this.tecList = res.retRes.slice(0,3);
        }else{
            this.tecList = res.retRes;
        }
        this.msLists = res.retRes;
      })
    },
    choseKm(e){
      this.nowKm = e
    },
    //跳转广告图
    gomsDetails(id) {
      this.$router.push({
        name: "StudioDetails",
        query: {
            id: id,
        },
      })
    },
    gomsrz() {
      this.$router.push({
        name: "Msrz",
        // query: {
        //     id: id,
        // },
      })
    },
    //点击课件前往课件详情或课件包详情
    goresDetails(id, lx, suffix) {
      //有分类型，并且类型为备课资源包
      if (lx && lx == 2 && suffix != "rar" && suffix != "zip") {
        let { href } = this.$router.resolve({
          path: "/resource/beikeziyuan",
          query: {
            id: id,
            path: this.$route.path,
            routeName: "首页",
          },
        });
        window.open(href, "_blank");
        //有分类型，并且类型为课件
      } else if (lx && lx == 1 && suffix != "rar" && suffix != "zip") {
        // console.log("推荐课件")
        let { href } = this.$router.resolve({
          path: "/resource/resDetails",
          query: {
            id: id,
            path: this.$route.path,
            routeName: "首页",
          },
        });
        window.open(href, "_blank");
        //非推荐，全部为正常课件
      } else if (!lx && suffix != "rar" && suffix != "zip") {
        let { href } = this.$router.resolve({
          path: "/resource/resDetails",
          query: {
            id: id,
            path: this.$route.path,
            routeName: "首页",
          },
        });
        window.open(href, "_blank");
      } else if (suffix == "rar" || suffix == "zip") {
        let { href } = this.$router.resolve({
          path: "/resource/zipResDetails",
          query: {
            id: id,
            path: this.$route.path,
            routeName: "首页",
          },
        });
        window.open(href, "_blank");
      }
    },
    //分页
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      console.log(`当前页: ${val}`);
    },
  },
};
</script>
<style lang="less" scoped>
#container {
  background-color: #f0f2f5;
  main {
    margin: 0 auto;
    margin-top: 20px;
    width: 1200px;
    background-color: #f0f2f5;
    .top {
        display: flex;
        align-items: center;
        width: 1200px;
        height: 420px;
        background: #FFFFFF;
        border-radius: 10px;
        .bangdan{
            margin-left: 20px;
            width: 275px;
            height: 380px;
            background: #F5F7FA;
            border-radius: 10px;
            background-image: url('../../assets/img/5.0/tecStudio (5).png');
            background-size: 100%;
            background-repeat: no-repeat;
            .topPic{
                margin-bottom: 6px;
                width: 275px;
                height: 66px;
            }
            .bangTecLists{
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                .tec{
                    display: flex;
                    align-items: center;
                    // justify-content: center;
                    width: 240px;
                    height: 82px;
                    border-bottom: 1px solid #E6E6E6;
                    .pic{
                        margin: 0 20px 0 10px;
                        width: 55px;
                        height: 54px;
                        border-radius: 50%;
                        img{
                            width: 100%;
                            height: 100%;
                            border-radius: 50%;
                        }
                    }
                    .msg{
                        display: flex;
                        flex-direction: column;
                        .title{
                            display: flex;
                            align-items: center;
                            margin-bottom: 10px;
                            h3{
                                font-size: 16px;
                                color: #333333;
                            }
                            img{
                                margin-left: 5px;
                                width: 16px;
                                height: 16px;
                            }
                        }
                        p{
                            font-size: 14px;
                            color: #999999;
                            span{
                                color: #F6444E;
                            }
                        }
                    }
                }
            }
            .sqrz{
                margin: 0 auto;
                margin-top: 8px;
                width: 175px;
                height: 40px;
                font-size: 16px;
                color: #FFFFFF;
                line-height: 40px;
                text-align: center;
                background: #1E60EB;
                border-radius: 20px;
                cursor: pointer;
            }
        }
        .tecBox{
            position: relative;
            margin-left: 20px;
            width: 275px;
            height: 380px;
            background: #F5F7FA;
            border-radius: 10px;
            background-image: url('../../assets/img/5.0/tecStudio (7).png');
            background-size: 100%;
            background-repeat: no-repeat;
            cursor: pointer;
            .tips{
                position: absolute;
                top: 16px;
                right: 16px;
                width: 72px;
                height: 24px;
                background: #0000007a;
                border-radius: 4px;
                // opacity: 0.4;
                text-align: center;
                line-height: 24px;
                color: #FFF;
                font-size: 12px;
                cursor: pointer;
            }
            .pic{
                margin: 0 auto;
                margin-top: 110px;
                width: 88px;
                height: 88px;
                border-radius: 50%;
                border: 4px solid #FFF;
                img{
                    width: 100%;
                    height: 100%;
                    border-radius: 50%;
                }
            }
            .msg{
                display: flex;
                flex-direction: column;
                align-items: center;
                .title{
                    display: flex;
                    align-items: center;
                    margin-top: 14px;
                    margin-bottom: 10px;
                    h3{
                        font-size: 16px;
                        color: #333333;
                    }
                    img{
                        margin-left: 5px;
                        width: 16px;
                        height: 16px;
                    }
                }
                .subtitle{
                    font-size: 14px;
                    color: #999999;
                }
            }
            .bottom{
                position: absolute;
                bottom: 40px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                width: 275px;
                p{
                    font-size: 14px;
                    color: #333;
                    span{
                        color: #F6444E;
                    }
                }
            }
        }
        .tecBox:nth-of-type(2n-1){
            background-image: url('../../assets/img/5.0/tecStudio (1).png');
        }
        .tecBox:nth-of-type(3n+1){
            background-image: url('../../assets/img/5.0/tecStudio (2).png');
        }
    }
    .teschers {
        margin: 0 auto;
        margin-top: 10px;
        margin-bottom: 20px;
        width: 1200px;
        background: #ffffff;
        border-radius: 10px;
        .boxtitle {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 10px;
        .left {
            margin: 19px;
            margin-bottom: 15px;
            h4 {
            margin-right: 5px;
            font-size: 18px;
            color: #333;
            }
        }
        .right {
            margin-right: 17px;
            font-size: 12px;
            color: #999;
            cursor: pointer;
        }
        .right:hover {
            color: #1E60EB;
        }
        }
        .gongzuoshi{
        display: flex;
        flex-wrap: wrap;
        .gzsBox{
            display: flex;
            align-items: center;
            // justify-content: center;
            margin-left: 20px;
            margin-bottom: 20px;
            width: 566px;
            height: 220px;
            background: #FFFFFF;
            border: 2px solid #F5F5F5;
            .left{
            position: relative;
            display: flex;
            // align-items: center;
            padding-right: 20px;
            margin-left: 30px;
            width: 235px;
            height: 180px;
            border-right: 1px solid #E6E6E6;
            .pic{
                position: relative;
                margin-top: 20px;
                width: 88px;
                height: 88px;
                border-radius: 50%;
                overflow: hidden;
                box-shadow: -10px 0px 0px 1px #F5F5F5; 
                img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                display: block;
                }
            }
            .msg{
                margin-top: 26px;
                margin-left: 15px;
                h4{
                font-size: 16px;
                color: #333333;
                }
                p{
                margin: 4px 0 10px 0;
                font-size: 14px;
                color: #999999;
                }
                .zylj{
                font-size: 14px;
                color: #999999;
                span{
                    color: #F6444E;
                }
                }
                
            }
            .tip{
                position: absolute;
                bottom: 32px;
                left: -6px;
                padding: 0 10px;
                font-size: 14px;
                color: #666666;
                min-width: 80px;
                line-height: 24px;
                height: 24px;
                background: #F5F5F5;
                border-radius: 12px;
                border: 1px solid #CCCCCC;
                text-align: center;
            }
            }
            .right{
            display: flex;
            flex-direction: column;
            align-items: center;
            width: 285px;
            .fileList{
                position: relative;
                display: flex;
                // align-items: center;
                width: 285px;
                height: 80px;
                
                .pic{
                  margin-top: 10px;
                margin-left: 16px;
                width: 44px;
                height: 48px;
                img{
                    width: 100%;
                    height: 100%;
                }
                }
                .msg{
                margin-left: 14px;
                h4{
                    margin-top: 10px;
                    margin-bottom: 20px;
                    width: 200px;
                    font-weight: 400;
                    font-size: 14px;
                    color: #333333;
                    line-height: 18px;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 2; // 控制多行的行数
                    -webkit-box-orient: vertical;
                }
                p{
                    position: absolute;
                    right: 20px;
                    bottom: 10px;
                    color: #999999;
                    font-size: 12px;
                }
                }
            }
            .fileList:hover{
                background: #F5F5F5;
                .msg{
                h4{
                    color: #1E60EB;
                }
                }
            }
            p{
                font-size: 12px;
                color: #999999;
            }
            }
        }
        .gzsBox:hover{
            box-shadow: 0px 0px 10px 0px rgba(15,51,126,0.2);
            cursor: pointer;
            .left{
            .pic{
                box-shadow: -10px 0px 0px 1px #1E60EB; 
            }
            .tip{
                position: absolute;
                bottom: 32px;
                left: -6px;
                padding: 0 10px;
                font-size: 14px;
                color: #1E60EB;
                line-height: 24px;
                min-width: 80px;
                height: 24px;
                background: #EFF3FA;
                border-radius: 12px;
                border: 1px solid #1E60EB;
                text-align: center;
            }
            }
            .right{
            p{
                color: #1E60EB;
            }
            }
        }
        }
        .msBanner{
          position: relative;
          display: flex;
          justify-content: center;
          cursor: pointer;
          width: 1200px;
          .pic{
              margin-bottom: 20px;
              width: 1160px;
              height: 148px;
              background: #1A449C;
          }
          .msru{
            position: absolute;
            bottom: 40px;
            left: 50%;
            transform: translateX(-50%);
            width: 140px;
            height: 28px;
            background: #1E60EB;
            border-radius: 14px;
            font-size: 14px;
            color: #FFFFFF;
            line-height: 28px;
            text-align: center;
            cursor: pointer;
          }
        }
    }
  }
}
</style>
